import { createContext } from "react";

import { DevToolsContext } from "./types";

const context = createContext<DevToolsContext>({
	highlightComponents: false,
});

export default context;
